import PropTypes from 'prop-types';
import { Scrollspy } from '@makotot/ghostui';

const defaultProps = {
  className: null,
};

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default function ScrollSpyComponent({ className, children, ...props }) {
  return (
    <Scrollspy className={className} {...props}>
      {children}
    </Scrollspy>
  );
}

ScrollSpyComponent.defaultProps = defaultProps;
ScrollSpyComponent.propTypes = propTypes;
